














import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import VueRecaptcha from 'vue-recaptcha'

@Component({
  components: {
    VueRecaptcha
  }
})
export default class Recaptcha extends Vue {
  $refs!: {
    recaptcha: any
  }
  @Prop({ required: true, type: Boolean }) readonly visible!: boolean
  @Watch('visible')
  onVisibilityChange(visiblity: boolean) {
    if (visiblity) {
      this.$refs.recaptcha.execute()
    } else {
      this.$refs.recaptcha.reset()
    }
  }

  get siteKey(): string {
    return process.env.VUE_APP_RECAPTCHA_KEY
  }

  onVerify(verificationCipher: string) {
    this.$emit('verify', verificationCipher)
  }
  refreshRecaptcha() {
    this.$refs.recaptcha.reset()
  }
}
